// extracted by mini-css-extract-plugin
module.exports = {"cropButton":"style__cropButton___3utMg","button":"style__button___Mzo1O"};